module.exports = __webpack_public_path__ + "img/5cfe899.jpg";